<script>
import Velocity from 'velocity-animate'
export default {
  name: 'StaggeredTransition',
  functional: true,
  props: {
    speed: {
      type: Number,
      required: false,
      default: 200,
    },
    top: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  render(createElement, context) {
    const speed = context.props.speed
    const top = context.props.top

    var data = {
      props: {
        name: 'staggered-transition',
        appear: true,
        css: false,
      },
      on: {
        beforeEnter: function (el) {
          el.style.opacity = 0
          if (top) el.style.top = '200px'
        },
        enter: function (el, done) {
          var delay = el.dataset.index * speed * 0.75
          setTimeout(function () {
            Velocity(
              el,
              { opacity: 1, ...(top && { top }) },
              { duration: speed, complete: done }
            )
          }, delay)
        },
        leave: function (el, done) {
          var delay = el.dataset.index * speed * 0.75
          setTimeout(function () {
            Velocity(el, { opacity: 0 }, { duration: speed, complete: done })
          }, delay)
        },
      },
    }
    return createElement('transition-group', data, context.children)
  },
}
</script>
